interface ArrowUpIconProps {
  className?: string
}

export const ArrowUpIcon = ({ className }: ArrowUpIconProps) => {
  return (
    <svg
      className={className}
      width="12"
      height="6"
      viewBox="0 0 12 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 0.5L5.29289 4.79289C5.68342 5.18342 6.31658 5.18342 6.70711 4.79289L11 0.5"
        stroke="currentColor"
      />
    </svg>
  )
}
